import type { ContactOrderBatchCancelItem } from "../../../../../../../../../../api/kehrblatt/contact-orders"
import type { CancelReplanRow } from "../../../../../_logic/cancel-replan-contract"
import type { AnnouncementPlanActionIntent } from "../actions/announcementPlans"

const buildBatchItems = (rows: CancelReplanRow[]): ContactOrderBatchCancelItem[] =>
  rows
    .map((row) => row.activeContactOrder)
    .filter((order): order is ContactOrder => Boolean(order))
    .map((order) => ({
      case_id: order.case_id ?? null,
      contact_order_id: order.id,
    }))

export const buildAnnouncementPlanActionIntents = ({
  rows,
  directEndMode,
}: {
  rows: CancelReplanRow[]
  directEndMode: boolean
}): AnnouncementPlanActionIntent[] => {
  if (!rows.length) {
    return [
      {
        kind: "none",
        label: "Weiter",
        buttonType: "primaryButton",
      },
    ]
  }

  const items = buildBatchItems(rows)

  if (directEndMode) {
    return [
      {
        kind: "cancel",
        label: "Ankündigungsplan abbrechen",
        buttonType: "secondaryButton",
        items,
      },
      {
        kind: "complete",
        label: "Ankündigungsplan abschließen",
        buttonType: "primaryButton",
        items,
      },
    ]
  }

  return [
    {
      kind: "cancel",
      label: "Bestehende Ankündigungspläne abbrechen",
      buttonType: "primaryButton",
      items,
    },
  ]
}
